import { render, staticRenderFns } from "./SensitiveKeywordsRuleList.vue?vue&type=template&id=75644cdb&scoped=true"
import script from "./SensitiveKeywordsRuleList.vue?vue&type=script&lang=js"
export * from "./SensitiveKeywordsRuleList.vue?vue&type=script&lang=js"
import style0 from "./SensitiveKeywordsRuleList.vue?vue&type=style&index=0&id=75644cdb&prod&lang=scss&scoped=true"
import style1 from "./SensitiveKeywordsRuleList.vue?vue&type=style&index=1&id=75644cdb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75644cdb",
  null
  
)

export default component.exports